import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { BrowserRouter, Routes, Route, Outlet, Navigate } from "react-router-dom";
import Example from "../components/SalePanel";
import HomePage from "../pages/HomePage";
import Marketplace from "../pages/Marketplace";
import Login from "../pages/Login";
import MyList from "../pages/MyList";
import EthicsPage from "../pages/EthicsPage";
import TermsPage from "../pages/TermsPage";
import PressPage from "../pages/PressPage";
import PrivacyPage from "../pages/PrivacyPage";
import ProductList from "../pages/ProductList";
import PropertiesList from "../pages/PropertiesList";
import { Wallet } from "../pages/wallets";
import { getCategories, getProductNames } from "../Redux/options/slice";
import { getProductsList } from "../Redux/products/slice";
import { ProtectedRoute } from "./ProtectedRoute";
import TransactionExplorer from "../components/TransactionExplorer";
import MyGPT from "../pages/VertoGPT";
import Footer from "../components/Footer";
import SecondFooter from "../components/SecondFooter";
import CertificatePage from "../components/CertificatePage";
import ProfilePresentation from "../components/ProfilePresentation";
import CookiesPolicy from "../pages/CookiesPolicy";
import MenuPanel from "../components/MenuPanel"; // Import MenuPanel
import { ResetPasswordPage } from "../pages/ResetPasswordPage";
import EudrReportsPage from "../pages/EudrReportsPage";
import SignUpFormPage from "../pages/SignUpFormPage";
import { BASE_URL } from "../Redux/apiConfig";
import GuidedTour from "../components/GuidedTour";
import axios from "axios";

// Create a Layout component that includes MenuPanel and Outlet
const Layout = ({ level = "1" }) => {
  return (
    <>
      <MenuPanel level={level} onStartTour={() => {}} />
      <div className="d-flex flex-column sticky-footer">
        <Outlet />
      </div>
      <SecondFooter />
      <Footer />
    </>
  );
};

const WebRouter = () => {
  const dispatch = useDispatch();
  
  useEffect(() => {
    dispatch(getCategories());
    dispatch(getProductsList());
    // dispatch(getProductNames())
  }, []);

  return (
    <BrowserRouter>
      <Routes>
        {/* Login route outside of layout */}
        <Route path="/login" element={<Login />} />
        <Route path="/certificate/:id" element={<CertificatePage />} />
        <Route path="/productcertificate/:id" element={<CertificatePage />} />
        <Route path="/profile/:accountId" element={<ProfilePresentation />} />
        <Route path="/reset-password/:token" element={<ResetPasswordPage />} />
        <Route path="/signup" element={<Navigate to="/signup-form" replace />} />
        {/* Routes with MenuPanel */}
        <Route element={<Layout />}>
          <Route index element={<HomePage />} />
          <Route path="/marketplace" element={<Marketplace />} />
          <Route 
            path="/my-list" 
            element={
              <ProtectedRoute>
                <MyList />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/wallet/:userId/:walletId" 
            element={
              <ProtectedRoute>
                <Wallet />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/wallet" 
            element={
              <ProtectedRoute>
                <Wallet />
              </ProtectedRoute>
            } 
          />
          <Route path="/gpt" element={<MyGPT />} />
          <Route path="/signup-form" element={<SignUpFormPage />} />
          <Route 
            path="/eudr-reports" 
            element={
              <ProtectedRoute>
                <EudrReportsPage />
              </ProtectedRoute>
            } 
          />
          <Route path="/transaction-explorer" element={<TransactionExplorer />} />
          <Route path="/ethics" element={<EthicsPage />} />
          <Route path="/cookies-policy" element={<CookiesPolicy />} />
          <Route path="/terms" element={<TermsPage />} />
          <Route path="/privacy" element={<PrivacyPage />} />
          <Route path="/press" element={<PressPage />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
};

export default WebRouter;